import React from 'react';
import './App.css';
import Header from './Components/Header';
import { resumeData } from './resumeData';

const App = () => {
    return (
        <div className="App">
            <Header data={resumeData.main} />
        </div>
    );
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js